const CONVERTER_PATH = "/tools/wpg-fx-converter/index.html";

export function WpgFxConverterPage(): JSX.Element {
  return (
    <div className="space-y-6">
      <div className="flex justify-end">
        <a
          href={CONVERTER_PATH}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700"
        >
          Open standalone
        </a>
      </div>

      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700">
        <iframe
          title="WPG FX Converter"
          src={CONVERTER_PATH}
          className="h-[1200px] w-full bg-white"
        />
      </div>
    </div>
  );
}
